import { useState } from "react";

const UtilizationExpenseDonut = ({ percent = 0, color, track }) => {
  const [isHovered, setIsHovered] = useState(false);
  const safePercent = Math.max(0, Math.min(100, Number(percent) || 0));
  const ringColor = color || "#2490EA";
  const ringTrack = track || "#DFF0FF";

  return (
    <div
      className={`utilization-donut ${isHovered ? "utilization-donut--hovered" : ""}`}
      style={{
        background: `conic-gradient(${ringColor} ${safePercent}%, ${ringTrack} ${safePercent}%)`,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="utilization-donut__label" style={{ color: ringColor }}>
        {safePercent}%
      </span>
    </div>
  );
};

export default UtilizationExpenseDonut;
